'use client';

import type { FC } from 'react';

import S from './styles.module.scss';

export interface IProgressIndicatorProps {
  /** Current progress of the associated media element as a number from 0 to 1. */
  progress: number;
}

const size = 100;
const stroke = 5;
const center = size / 2;
const radius = (size - stroke) / 2;
const circumference = radius * 2 * Math.PI;

/** Progress indicator component for a media element. */
export const ProgressIndicator: FC<IProgressIndicatorProps> = ({
  progress
}) => {
  const offset = progress * circumference;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className={S.progress}
    >
      <circle
        fill="none"
        stroke="currentColor"
        strokeWidth={stroke}
        strokeDasharray={`${circumference}, ${circumference}`}
        strokeDashoffset={offset}
        cx={center}
        cy={center}
        r={radius}
      />
    </svg>
  );
};
